function getCountryFromUrl() {
  var url = window.location.href;
  var match = url.match(/[?&]country=([A-Z]{2})/i);
  if (match && match[1]) return match[1].toUpperCase();
  return null;
}

function getCountryFromPath() {
  var path = window.location.pathname;
  var match = path.match(/\/[a-z]+-([A-Z]{2})\//i) || path.match(/\/([A-Z]{2})\//i);
  if (match && match[1]) return match[1].toUpperCase();
  return null;
}

function getSelectedMarketCountry() {
  var logger = window.createLogger('CountryManager');

  // 1. Explicit ?country= query param (highest priority)
  var urlCountry = getCountryFromUrl();
  if (urlCountry) {
    logger.log('getSelectedMarketCountry: from URL param:', urlCountry);
    return urlCountry;
  }

  // 2. Path-based country
  var pathCountry = getCountryFromPath();

  // 3. For the shared EU market (/en-eu/) the path yields 'EU' which is not a
  //    real country.  Resolve the actual country from:
  //      a. localStorage (most recent explicit selection, e.g. from shipping calculator)
  //      b. CartItemsData.destination (server-rendered correct country on page load)
  if (pathCountry === 'EU') {
    try {
      var lsCountry = localStorage.getItem('n4y_eu_country');
      if (lsCountry && lsCountry.length === 2) {
        logger.log('getSelectedMarketCountry: from localStorage (EU market):', lsCountry.toUpperCase());
        return lsCountry.toUpperCase();
      }
    } catch (_) {}

    if (window.CartItemsData && window.CartItemsData.destination &&
        window.CartItemsData.destination !== 'EU') {
      logger.log('getSelectedMarketCountry: from CartItemsData (EU market):', window.CartItemsData.destination);
      return window.CartItemsData.destination;
    }

    // Hard fallback — should not normally be reached after market-country.liquid fix
    logger.warn('getSelectedMarketCountry: EU market, no country resolved, defaulting to DE');
    return 'DE';
  }

  // 4. Direct path-based country (DE, FR) or default GB
  var resolved = pathCountry || 'GB';
  logger.log('getSelectedMarketCountry:', resolved);
  return resolved;
}

function is_EuCountry(countryCode) {
  const euCountriesMetaField = window.euCountries;
  return euCountriesMetaField && euCountriesMetaField[countryCode];
}
function country_NameByCode(countryCode) {
  const shippingCountriesMetaField = window.shippingCountries;
  return shippingCountriesMetaField ? shippingCountriesMetaField[countryCode].country : 'NA';
}

window.getSelectedMarketCountry = getSelectedMarketCountry;
window.is_EuCountry = is_EuCountry;
window.country_NameByCode = country_NameByCode;
